import Bugsnag from "@lib/bugsnag";
import isServer from "@utils/is-server";
import CustomError from "@components/core/CustomError/CustomError";

const Error = ({ statusCode }) => <CustomError statusCode={statusCode} />;

Error.getInitialProps = (ctx) => {
  if (isServer() && ctx.err) {
    const { user } = ctx.store.getState();
    Bugsnag.notify(ctx.err, (event) => {
      event.setUser(user);
      event.addMetadata("page", {
        pathname: ctx.asPath,
        query: ctx.query,
      });
    });
  }

  let statusCode;
  if (ctx.res) {
    statusCode = ctx.res.statusCode;
  } else if (ctx.err) {
    statusCode = ctx.err.statusCode;
  } else {
    statusCode = 404;
  }
  return {
    statusCode,
    namespacesRequired: [],
    headerBehaviors: { noNavbar: true, noFooter: true },
  };
};

Error.requireAuth = false;

export default Error;
